<template>
  <div>
    <el-form-item
      :label=" $t('高度')"
    >
      <el-input-number
        v-model="width"
        controls-position="right"
        :placeholder="$t('请输入')"
        :min="20"
      ></el-input-number>
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: "table-layout-td",
  inject: ["formDesign"],
  props: ["data"],
  data() {
    return {
    };
  },
  computed: {
    config() {
      return this.data.cell;
    },
    width:{
      get(){
        return this.config.height
      },
      set(val){
        this.$set(this.config,'height',val)
      }
    }
  },
  methods: {},
};
</script>
